import BaseElement from './BaseElement';
import { WishlistCreateList } from '../components/WishlistCreateList'

export default class WishlistCreateListElement extends BaseElement {
  static get observedAttributes () {
    return ['product', 'variant-selected-id']
  }

  renderElement () {
    this.rootElement.render(<WishlistCreateList />)
  }
}
